import React from 'react';
import H2HeaderText from '../ui/typography/H2HeaderText';
import BaseText from '../ui/typography/BaseText';
import BlogCards from '../ui/cards/BlogCard';

export default function OurBlogs({ our_blog, title, subTitle, titleFontWeight, bgColor }) {
  return (
    <section className={` ${bgColor} py-4`}>
      <div className={`global-max-width-wrapper mx-auto my-24 gap-12 ${bgColor}`}>
        <H2HeaderText fontWeight={titleFontWeight} textAlign="text-center" title={title} />
        <BaseText
          textAlign="text-center"
          textColor="text-gray-300"
          className="mt-2 mb-16"
          fontWeight="text-medium"
          title={subTitle}
        />
        {our_blog && (
          <div className="flex flex-wrap gap-6">
            {our_blog?.map((blog) => (
              <BlogCards
                title={blog?.linked_blog?.document?.data?.title?.text}
                description={blog?.linked_blog?.document?.data?.description?.text}
                image={blog?.linked_blog?.document?.data?.image}
                uid={blog?.linked_blog?.document?.uid}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

OurBlogs.defaultProps = {
  title: 'Our Blog',
  subTitle: 'Practical resources for Entrepreneurs and SMEs',
  bgColor: 'bg-white'
};
